import template from './add_rating_method.html';
import * as Utils from '../../lib/savanna_utils.js';

class AddRatingMethodViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.name = ko.observable();
		this.description = ko.observable();
		this.categories = ko.observableArray();
		this.selected_category = ko.observable();
		this.types = ko.observableArray(['single-select', 'multiselect', 'range', 'input', 'number']);
		this.selected_type = ko.observable();
	};

	close()
	{
		this.dialog.close();
	}

	async btn_save()
	{
		if (!this.name())
		{
			Grape.alerts.alert({ type: 'warning', message: "Rating Method's name cannot be empty!"});
			return;
		}
		else
		{
			try {
				let res = await Grape.fetches.postJSON('/performance_management/rating_method/edit', {
					name: this.name(),
					description: this.description(),
					type: this.selected_type(),
					category: this.selected_category()
				});
				if (res.status != 'ERROR')
				{
					if (res.status == 'OK')
						Grape.alerts.alert({ type: 'success', message: 'Rating method added successfully' });
					this.dialog.close();
				}
			} catch (error) {
				console.error(error);
				Grape.alerts.alert({ type: 'error', message: 'An error occurred - ', error});
			}
		}
	}
};

class AddRatingMethodPage
{
	constructor (bindings)
	{
		this.viewModel = new AddRatingMethodViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		Utils.refresh_data_visible_roles();
	}

	async updateData()
	{

	}
};

export default {
	name: 'AddRatingMethod',
	dialog_class: AddRatingMethodPage,
	template: template,
	template_filename: 'translation/dialogs/add_rating_method',
	provider: 'ps'
};